import { Injectable } from '@angular/core';
import { CONFIG } from "../../config/config";
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AccountsService {

  constructor(
    public http: HttpClient,
    public router: Router,
  ) { }

  getAllAccounts(accountType:string) {
    return this.http.get(`${CONFIG.API_PROD}accounts/${accountType}`)
  }

}